import { pagesPath } from '@/shared/config/$path';

import { BreadcrumbsItem } from './breadcrumbs-item';

interface BreadcrumbsProps {
  paths: ([string] | [string, string])[];
}

export const Breadcrumbs = (props: BreadcrumbsProps) => {
  const { paths } = props;

  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol className="inline-flex items-center overflow-auto whitespace-nowrap">
        <BreadcrumbsItem href={pagesPath.$url()}>Главная</BreadcrumbsItem>

        {paths.map(([name, path], index) => (
          <BreadcrumbsItem key={path || index} href={path} isCurrentPage={index === paths.length - 1}>
            {name}
          </BreadcrumbsItem>
        ))}
      </ol>
    </nav>
  );
};
